<template>
  <v-app class="grey lighten-4" v-if="access">
    <Navbar 
    v-if="isLogin"
    :userName="userData? userData.displayName ? userData.displayName :  userData.email : null "
    :userImage="userData? userData.photoURL ? userData.photoURL : null : null "
    :progress="progress"
    :userRole="userRole"
    :userData="userData? userData : null"
    :scroll="scroll"
    :superAdmin="superAdmin"
    :scrollAmount="scrollAmount"
    :connection="connection"
    />
    
    <v-content>
      <v-alert
        :value="alert"
        :type="type"
        transition="scale-transition"
      >
        {{ alertText }}
      </v-alert>
      <transition :name="transitionName"> 
        <router-view
          :isLogin="isLogin"
          :userRole="userRole"
          :beta="beta"
          :warehouse="warehouse"
          :superAdmin="superAdmin"
          :userData="userData? userData : null"
          :userName="userData? userData.displayName ? userData.displayName : userData.email : null"
          :userImage="userData? userData.photoURL ? userData.photoURL : null : null"
          @snackbarNotification="getSnack"
          @alertNotification="getAlert"
          @progressBar='getProgress'
          @scrollBar="getScroll"
        ></router-view>
      </transition>
    </v-content>
      <v-snackbar v-model="snackbar" :color="type" :timeout="4000" :bottom="type == 'error'" :top="type == 'success'" >
        <span>{{ snackbarContent }}</span>
        <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <LeadView />
    <Footer />
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
import Footer from './components/footer'
import LeadView from './components/LeadView'
import Chat from './components/ChatWindow'
import { firebase, db, auth, perf } from '@/fb'
const trace = perf.trace('inAppTime');

export default {
  components: { Navbar, Footer, Chat, LeadView },
  name: 'App',
  data () {
    return {
      access:false,
      isLogin:false,
      transitionName:null,
      userData:null,
      snackbar:false,
      snackbarContent:'',
      alert:false,
      alertText:null,
      type:null,
      progress:null,
      scroll:false,
      connection:null,
      userRole:null,
      scrollAmount:0,
      beta:null,
      superAdmin:null,
      warehouse:null,
    }
  },
  methods: {
    getSnack (text, type) {
      this.snackbar = true
      this.snackbarContent = text
      this.type = type
    },
    getAlert (text, type) {
      this.alert = true
      this.alertText = text
      this.type = type
      setTimeout(()=>{this.alert = false}, 4000)
    },
    getProgress(val){
      this.progress = val
    },
    getScroll(status, amount) {
      this.scroll=status
      this.scrollAmount=amount
    },
    showSnackbar (text, type) {
      this.$emit('snackbarNotification', text, type)
    },
    statusCheck(){
      var connectedRef = firebase.database().ref(".info/connected");
      connectedRef.on("value", (snap) => {
        if (snap.val() === true) {
          this.getSnack ('You are now connected', 'success')
          this.connection = 'success'
        } else {
          this.getSnack ('You are not connected', 'error')
          this.connection = 'error'
        }
      });
      let updateIndicator = () => {
        if(navigator.onLine) { // true|false
          this.getSnack ('You are now Online', 'success')
          this.connection = 'success'
        } else {
          this.getSnack ('You are now Offline', 'error')
          this.connection = 'error'
        }
      }
      window.addEventListener('online',  updateIndicator);
      window.addEventListener('offline', updateIndicator);
    }
  }, 
  watch: {
    $route (to, from){
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      if (this.$router.history.current.name == 'login') {
        this.access = true
      } else if(!this.isLogin) {
        this.access = false
        this.$router.push('/login')
      }
    }
  },
  created() {
    auth.onAuthStateChanged(user => {
      if (user) {
        this.isLogin = true;
        this.userData = user;
        this.$store.state.user = user
        this.$emit('signedIn', this.userData)
        this.statusCheck() 
        var d = new Date();
        var store = Date.parse(d)
        var offset = d.getTimezoneOffset();
        console.log(new Date(store))
        let newUser = {
          user_id: user.uid,
          email: user.email,
          name: user.displayName,
          phone: user.phoneNumber,
          qa: user.qa,
          // role:'user',
          provider: user.providerData,
          timeoffset: offset,
          lastSeen:store,

        }
        db.ref(`users/${user.uid}`)
        .update(newUser)
        db.ref(`users/${user.uid}`)
        .on('value', snap=>{
          if (snap.val()) {
            let x = snap.val()
            this.$store.state.user = x
            this.$store.state.role = x.role ? x.role : 'user'
            this.userRole = x.role ? x.role : 'user'
            this.beta = x.beta
            this.superAdmin = x.superadmin
            this.warehouse = x.warehouse
            this.access = x.access
            this.inf = x.inf
            this.$store.state.inf = x.inf
            this.userData = {...user, ...x};
          }
        })
      } else {
        this.isLogin = false;
        this.userData = null;
        if (this.$router.history.current.name == 'login') {
          this.access = true
        } else {
          this.access = false
          this.$router.push('/login')
        }
      }
    });
    trace.start();
  },
  mounted() {
  },
  destroyed(){
    trace.stop();
  }
}
</script>
<style>
::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.22);
    background-color: #F5F5F5;
}

::-webkit-scrollbar
{
	width: 5px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
	background-color: #0d47a1;
	border-radius:  0 0 20px 20px; 
}
</style>
